import { render, staticRenderFns } from "./UserDetailPopover.vue?vue&type=template&id=089af649"
import script from "./UserDetailPopover.vue?vue&type=script&lang=js"
export * from "./UserDetailPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports